export function bucketData(
  dataToBeBucketed: number[],
  minBucketValue: number,
  bucketWidth: number,
  bucketCount: number,
  nextBucketDiff: number = 0.01,
) {
  const buckets: { min: number; max: number; values: number[] }[] = [];
  const sortedData = [...dataToBeBucketed].sort((a, b) => a - b);
  let currentDataIndex = 0;

  for (let i = 0; i < bucketCount; i++) {
    let minCurrBucketValue = minBucketValue + i * bucketWidth;
    const maxCurrBucketValue = minCurrBucketValue + bucketWidth;
    const currentBucketData = [];
    if (i > 0) {
      minCurrBucketValue += nextBucketDiff;
    }
    while (
      currentDataIndex < sortedData.length &&
      sortedData[currentDataIndex] < minCurrBucketValue
    ) {
      currentDataIndex++;
    }
    while (
      currentDataIndex < sortedData.length &&
      sortedData[currentDataIndex] <= maxCurrBucketValue
    ) {
      currentBucketData.push(sortedData[currentDataIndex]);
      currentDataIndex++;
    }
    buckets.push({
      min: minCurrBucketValue,
      max: maxCurrBucketValue,
      values: currentBucketData,
    });
  }

  return buckets;
}
